import { useMutation } from 'react-query';
import { useActions } from '../../../../context/Actions.context';
import Endpoints from '../../../constants/endpoints';
import { useServices } from '../../../services/useServices';
import { IGetBookListParams } from '../book.dto';
interface IUpdateTitleVariables {
  params: IGetBookListParams;
  body?: Record<string, unknown>;
}

export const useUpdateTitle = (name: string) => {
  const { book: { updateTitle } } = useServices();
  const { source: sourcePath } = useActions();
  const sourceTab = window.location.pathname.split('/')[2];

  const endpoints = {
    source: sourcePath['source'],
    sourceTab,
    endpoint: Endpoints[name],
    action: name
  };

  return useMutation(
    'add-to-list',
    (variables: IUpdateTitleVariables | IGetBookListParams) => {
      if ('params' in variables) {
        return updateTitle(endpoints, variables.params, variables.body);
      }
      return updateTitle(endpoints, variables, undefined);
    }
  );
};